import { Component, Inject, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SHARED_IMPORTS } from '../../shared/shared-imports';

interface Tenant {
	TenantId: string;
	TenantName: string;
}

@Component({
	selector: 'global-set-current-tenant',
	standalone: true,
	imports: [
		...SHARED_IMPORTS,
		MatSelectModule,
		MatOptionModule,
		MatButtonModule,
		MatFormFieldModule
	],
	templateUrl: 'components/global-admin/global-set-current-tenant/global-set-current-tenant.component.html',
	styleUrls: ['components/global-admin/global-set-current-tenant/global-set-current-tenant.component.css'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class GlobalSetCurrentTenantComponent implements OnInit {
	public selectedTenant: string = '';
	public tenants: Tenant[] = [];
		private router = inject(Router);
		private http = inject(HttpClient);

	constructor() { }

	ngOnInit(): void {
		this.http.get<Tenant[]>("/api/prototype/tenants").subscribe(tenants => {
			this.tenants = tenants;
		});
	}

	public setCurrentTenant(): void {
		if (this.selectedTenant) {
			this.http
				.get(`/api/prototype/setTenant/${this.selectedTenant}`)
				.subscribe(() => {
					// Navigate to Main state - we'll need to inject a router service
					// For now, we can use window.location or emit an event
					this.router.navigate(['/Main']);
				});

			this.http
				.post(`/api/Tenant/SetHomeTenant?tenantName=${this.selectedTenant}`, {})
				.subscribe(result => {
				});
		} else {
			alert('Must select a tenant first');
		}
	}
}
